import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ProductoPublicModel from '../models/ProductoPublicModel';
import CafeVerdePublicModel from '../models/CafeVerdePublicModel';
import TourPublicModel from '../models/TourPublicModel';

// IMPORTAMOS IMÁGENES LOCALES (Las imágenes sí pueden ir en src/assets)
import vid1 from '../assets/vd1.mp4';
import vid2 from '../assets/vd2.mp4';
import vid3 from '../assets/vd3.mp4';
import vid4 from '../assets/vd4.mp4';

// IMPORTAMOS IMÁGENES LOCALES
import fincaImg from '../assets/finca.jpg';
import romanImg from '../assets/roman-catador.jpg';
import historiaImg from '../assets/historia-familia.jpg';
import cocinaHumoImg from '../assets/cocina-humo.jpg';
import bosqueImg from '../assets/bosque.jpg';
import xicotepecImg from '../assets/xicotepec.jpg';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [greenCoffeeVarieties, setGreenCoffeeVarieties] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    people: '2',
    message: '',
    includeBuffet: false,
    includeCatacion: true,
    includeRecorrido: true
  });

  const [contactData, setContactData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    tonnage: '1',
    quality: '',
    message: ''
  });

  useEffect(() => {
    cargarDatosInicio();
  }, []);

  const cargarDatosInicio = async () => {
    setLoading(true);
    try {
      // Cargar productos destacados
      const productos = await ProductoPublicModel.getDestacados();
      setFeaturedProducts(productos.length > 0 ? productos : [
        {
          id: 1,
          nombre: 'Café Premium Altura',
          descripcion_corta: 'Grano seleccionado de nuestras mejores cosechas',
          precio: 250,
          imagen_portada: 'https://images.unsplash.com/photo-1442512595331-e89e73853f31',
          categoria: 'Café en Grano'
        },
        {
          id: 2,
          nombre: 'Licor de Café Artesanal',
          descripcion_corta: 'Elaborado con nuestra receta familiar',
          precio: 350,
          imagen_portada: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd',
          categoria: 'Licor'
        },
        {
          id: 3,
          nombre: 'Bombones de Café',
          descripcion_corta: 'Chocolate relleno con crema de café',
          precio: 180,
          imagen_portada: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735',
          categoria: 'Bombones'
        },
        {
          id: 4,
          nombre: 'Galletas de Café',
          descripcion_corta: 'Horneadas con nuestra receta secreta',
          precio: 120,
          imagen_portada: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085',
          categoria: 'Galletas'
        }
      ]);

      // Cargar variedades de café verde
      const verde = await CafeVerdePublicModel.getDisponibles();
      setGreenCoffeeVarieties(verde.length > 0 ? verde : [
        {
          nombre: 'Oro Natural Superior',
          origen: 'Xicotepec de Juárez, Puebla, México',
          altitud: '1,400 - 1,600 msnm',
          perfil_taza: 'Chocolate, nuez, caramelo'
        },
        {
          nombre: 'Oro PL-10',
          origen: 'Chiapas, México',
          altitud: '1,500 - 1,800 msnm',
          perfil_taza: 'Cítrico, floral, miel'
        },
        {
          nombre: 'Oro PL-20',
          origen: 'Oaxaca, México',
          altitud: '1,600 - 2,000 msnm',
          perfil_taza: 'Frutos rojos, vino tinto'
        },
        {
          nombre: 'Altura Premium',
          origen: 'Puebla, México',
          altitud: '1,700 - 2,100 msnm',
          perfil_taza: 'Chocolate amargo, especias'
        }
      ]);
    } catch (error) {
      console.error('Error cargando datos de inicio:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleTourSubmit = async (e) => {
    e.preventDefault();
    
    const numPersonas = parseInt(formData.people);
    // Aplicar lógica: Siempre se cobra mínimo el equivalente a 4 personas
    const personasParaCobro = Math.max(4, numPersonas);

    const costoCatacion = formData.includeCatacion ? 200 * personasParaCobro : 0;
    const costoRecorrido = formData.includeRecorrido ? 150 * personasParaCobro : 0;
    const costoTourCompleto = formData.includeCatacion && formData.includeRecorrido ? 300 * personasParaCobro : costoCatacion + costoRecorrido;
    const costoBuffet = formData.includeBuffet && numPersonas >= 10 ? 200 * numPersonas : 0;
    const costoTotal = costoTourCompleto + costoBuffet;

    try {
      // Guardar en la base de datos
      await TourPublicModel.create({
        nombre: formData.name,
        email: formData.email,
        telefono: formData.phone,
        fecha_reserva: formData.date,
        personas: numPersonas, // Guardamos las personas reales
        mensaje: formData.message,
        incluye_catacion: formData.includeCatacion,
        incluye_recorrido: formData.includeRecorrido,
        incluye_buffet: formData.includeBuffet
      });

      let mensaje = `¡Gracias por tu interés en visitar nuestra finca!\n\n`;
      mensaje += `📍 **Xicotepec de Juárez, Pueblo Mágico**\n`;
      mensaje += `🌲 **Sierra Norte de Puebla**\n\n`;
      mensaje += `📋 **RESUMEN DE TU RESERVACIÓN**\n`;
      mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
      mensaje += `👤 Nombre: ${formData.name}\n`;
      mensaje += `📧 Email: ${formData.email}\n`;
      mensaje += `📞 Teléfono: ${formData.phone}\n`;
      mensaje += `📅 Fecha: ${formData.date || 'Por definir'}\n`;
      mensaje += `👥 Personas asistiendo: ${numPersonas}\n`;
      mensaje += `⚠️ Cobro aplicado por mínimo de: ${personasParaCobro} personas\n\n`;
      
      mensaje += `💰 **DETALLE DE COSTOS**\n`;
      mensaje += `━━━━━━━━━━━━━━━━━━\n`;
      mensaje += `🎫 Tour (${personasParaCobro} personas cobradas): $${costoTourCompleto} MXN\n`;
      
      if (formData.includeBuffet) {
        if (numPersonas >= 10) {
          mensaje += `🍽️ Cocina Tradicional de Humo: $${costoBuffet} MXN\n`;
        } else {
          mensaje += `⚠️ Cocina tradicional no incluida (mínimo 10 personas)\n`;
        }
      }
      
      mensaje += `\n💵 **TOTAL ESTIMADO: $${costoTotal} MXN**\n\n`;
      mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━\n`;
      mensaje += `Te contactaremos en máximo 24 horas para confirmar disponibilidad.\n`;
      mensaje += `\n¡Gracias por elegir Román Valderrábano El Catador! ☕`;

      alert(mensaje);
    } catch (error) {
      alert('Hubo un error al procesar tu reservación. Por favor intenta de nuevo.');
    }
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    
    let mensaje = `📦 **SOLICITUD DE COTIZACIÓN - CAFÉ VERDE**\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
    mensaje += `👤 Nombre: ${contactData.name}\n`;
    mensaje += `📧 Email: ${contactData.email}\n`;
    mensaje += `🏢 Empresa: ${contactData.company || 'No especificada'}\n`;
    mensaje += `📞 Teléfono: ${contactData.phone}\n`;
    mensaje += `📦 Cantidad: ${contactData.tonnage} tonelada(s)\n`;
    mensaje += `⚡ Calidad: ${contactData.quality || 'Por definir'}\n`;
    mensaje += `📝 Mensaje: ${contactData.message || 'Sin mensaje adicional'}\n\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    mensaje += `Un asesor comercial te contactará en máximo 24 horas.\n`;
    mensaje += `Gracias por tu interés en Román Valderrábano El Catador.`;

    alert(mensaje);
    console.log('Contacto comercial:', contactData);
  };

  // Función para abrir redes sociales
  const openSocial = (url) => {
    window.open(url, '_blank', 'noopener noreferrer');
  };

  // ✅ FUNCIÓN CORREGIDA PARA LAS IMÁGENES DE PRODUCTOS
  const getImageUrl = (imageName) => {
    if (!imageName) return '/images/default-product.jpg';
    if (imageName.startsWith('http') || imageName.startsWith('data:image')) return imageName;
    return `https://api.romanvalderrabanoelcatador.com/api/uploads/productos/${imageName}`;
  };

  if (loading) {
    return (
      <div className="loading-container" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', background: '#F9F6F0'}}>
        <div className="spinner" style={{width: '50px', height: '50px', border: '5px solid #8B4513', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite'}}></div>
        <p style={{marginTop: '1rem', color: '#8B4513', fontWeight: 'bold'}}>Preparando la experiencia...</p>
        <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      <SEO 
        title="Román Valderrábano El Catador - Café de Especialidad desde 1880"
        description="Desde 1880 produciendo café de especialidad en la Sierra Norte de Puebla. Tours guiados por bosque mesófilo, catación con Q Grader y cocina tradicional de humo en Xicotepec, Pueblo Mágico."
        keywords="Román Valderrábano, El Catador, café de especialidad Xicotepec, café Puebla, catador Q Grader, café orgánico, tour cafetalero, cocina de humo"
        url="https://romanvalderrabanoelcatador.com/"
        image={fincaImg}
      />
      
      {/* INTEGRACIÓN DE ESTILOS CSS EN EL COMPONENTE */}
      <style>{`
        :root {
          --primary-color: #8B4513;
          --primary-hover: #A0522D;
          --secondary-color: #D2B48C;
          --dark-bg: #1A1A1A;
          --light-bg: #F9F6F0;
          --text-main: #2C2C2C;
          --text-light: #666666;
          --white: #FFFFFF;
          --radius-md: 12px;
          --radius-lg: 24px;
          --shadow-sm: 0 4px 6px rgba(0, 0, 0, 0.05);
          --shadow-md: 0 10px 30px rgba(0, 0, 0, 0.08);
          --shadow-lg: 0 20px 40px rgba(0, 0, 0, 0.12);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .home-container {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          color: var(--text-main);
          background-color: var(--light-bg);
          overflow-x: hidden;
        }
        
        /* HERO SECTION */
        .hero-section {
          position: relative;
          min-height: 90vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: var(--dark-bg);
          color: var(--white);
          padding: 0 5%;
          overflow: hidden;
        }
        
        .hero-background {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background-image: linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.5) 100%);
          z-index: 1;
        }
        
        .hero-background-img {
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          object-fit: cover;
          opacity: 0.6;
          z-index: 0;
        }
        
        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          text-align: center;
        }
        
        .hero-subtitle-top {
          color: var(--secondary-color);
          text-transform: uppercase;
          letter-spacing: 4px;
          font-size: 0.9rem;
          font-weight: 700;
          margin-bottom: 1rem;
          display: block;
        }
        
        .hero-title {
          font-size: 4.5rem;
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', Georgia, serif;
        }
        
        .hero-title .hero-subtitle {
          display: block;
          color: var(--secondary-color);
          font-style: italic;
          font-weight: 400;
        }
        
        .hero-description {
          font-size: 1.25rem;
          color: #E0E0E0;
          margin-bottom: 1rem;
          line-height: 1.6;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
        }
        
        .hero-description-small {
          font-size: 0.95rem;
          color: #B0B0B0;
          margin-bottom: 2.5rem;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        }
        
        .hero-buttons {
          display: flex;
          gap: 1.5rem;
          justify-content: center;
          margin-bottom: 4rem;
        }
        
        .hero-stats {
          display: flex;
          justify-content: center;
          gap: 3rem;
          border-top: 1px solid rgba(255,255,255,0.2);
          padding-top: 2rem;
        }
        
        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        
        .stat-number {
          font-size: 2rem;
          font-weight: 800;
          color: var(--secondary-color);
        }
        
        .stat-label {
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #CCC;
        }
        
        /* BOTONES GLOBALES */
        .btn-premium {
          background-color: var(--primary-color);
          color: var(--white);
          padding: 1rem 2.5rem;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          transition: var(--transition);
          border: 2px solid var(--primary-color);
          cursor: pointer;
        }
        
        .btn-premium:hover {
          background-color: transparent;
          color: var(--primary-color);
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(139, 69, 19, 0.3);
        }
        
        .hero-section .btn-premium:hover {
          color: var(--white);
        }
        
        .btn-outline-light {
          background-color: transparent;
          color: var(--white);
          padding: 1rem 2.5rem;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          transition: var(--transition);
          border: 2px solid rgba(255,255,255,0.3);
          backdrop-filter: blur(5px);
          cursor: pointer;
        }
        
        .btn-outline-light:hover {
          background-color: var(--white);
          color: var(--dark-bg);
          transform: translateY(-3px);
        }
        
        /* ENCABEZADOS DE SECCIÓN */
        .section-header-dark, .section-header-light {
          text-align: center;
          margin-bottom: 4rem;
        }
        
        .section-header-dark h2 {
          font-size: 3rem;
          font-family: 'Playfair Display', serif;
          color: var(--white);
          margin-bottom: 1rem;
        }
        
        .section-header-dark p {
          color: var(--secondary-color);
          font-size: 1.1rem;
        }
        
        .section-header-light h2 {
          font-size: 3rem;
          font-family: 'Playfair Display', serif;
          color: var(--text-main);
          margin-bottom: 1rem;
        }
        
        .section-header-light p {
          color: var(--text-light);
          font-size: 1.1rem;
        }
        
        .subtitle-top {
          color: var(--primary-color);
          text-transform: uppercase;
          letter-spacing: 3px;
          font-weight: bold;
          font-size: 0.85rem;
          display: block;
          margin-bottom: 0.5rem;
        }
        
        /* VIDEOS SECTION & PANORAMA */
        .videos-section, .panorama-section {
          background-color: var(--dark-bg);
          padding: 6rem 5%;
          color: var(--white);
        }
        
        .panorama-container {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .videos-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .video-card {
          background: rgba(255,255,255,0.05);
          border-radius: var(--radius-lg);
          overflow: hidden;
          border: 1px solid rgba(255,255,255,0.1);
          transition: var(--transition);
        }
        
        .video-card:hover {
          transform: translateY(-10px);
          border-color: var(--secondary-color);
          box-shadow: 0 15px 30px rgba(0,0,0,0.5);
        }
        
        .video-container video {
          width: 100%;
          aspect-ratio: 16/9;
          object-fit: cover;
          background: #000;
        }
        
        .video-info {
          padding: 1.5rem;
        }
        
        .video-info h3 {
          font-size: 1.25rem;
          margin-bottom: 0.5rem;
          color: var(--white);
        }
        
        .video-info p {
          color: #A0A0A0;
          font-size: 0.9rem;
          line-height: 1.5;
        }
        
        /* PRODUCTOS DESTACADOS */
        .featured-products {
          padding: 6rem 5%;
          max-width: 1300px;
          margin: 0 auto;
        }
        
        .products-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 2rem;
        }
        
        .product-card {
          background: var(--white);
          border-radius: var(--radius-md);
          overflow: hidden;
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
          display: flex;
          flex-direction: column;
          border: 1px solid #EEEEEE;
        }
        
        .product-card:hover {
          transform: translateY(-8px);
          box-shadow: var(--shadow-md);
          border-color: var(--secondary-color);
        }
        
        .product-link {
          text-decoration: none;
          color: inherit;
          display: block;
          flex-grow: 1;
        }
        
        .product-image-container {
          position: relative;
          width: 100%;
          aspect-ratio: 1 / 1;
          overflow: hidden;
          background: #F5F5F5;
        }
        
        .product-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        
        .product-card:hover .product-image {
          transform: scale(1.08);
        }
        
        .product-badge {
          position: absolute;
          top: 1rem;
          left: 1rem;
          background: var(--dark-bg);
          color: var(--white);
          padding: 0.3rem 0.8rem;
          font-size: 0.75rem;
          font-weight: bold;
          border-radius: 20px;
          text-transform: uppercase;
        }
        
        .product-info {
          padding: 1.5rem;
        }
        
        .product-category {
          font-size: 0.8rem;
          color: var(--primary-color);
          text-transform: uppercase;
          font-weight: bold;
          display: block;
          margin-bottom: 0.5rem;
        }
        
        .product-name {
          font-size: 1.25rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: var(--text-main);
        }
        
        .product-description {
          font-size: 0.9rem;
          color: var(--text-light);
          margin-bottom: 1.5rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        
        .product-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #EEE;
          padding-top: 1rem;
        }
        
        .product-price {
          font-size: 1.25rem;
          font-weight: 800;
          color: var(--primary-color);
        }
        
        .product-card-action {
          padding: 0 1.5rem 1.5rem 1.5rem;
        }
        
        .add-to-cart-btn-card {
          width: 100%;
          background: var(--light-bg);
          color: var(--primary-color);
          border: 1px solid var(--primary-color);
          padding: 0.8rem;
          border-radius: var(--radius-md);
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0.5rem;
        }
        
        .add-to-cart-btn-card:hover {
          background: var(--primary-color);
          color: var(--white);
        }
        
        /* 🔥 NUEVO DISEÑO PREMIUM PARA ABOUT SECTION 🔥 */
        .about-section {
          padding: 8rem 5%;
          background-color: var(--white);
          position: relative;
        }
        
        .about-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1.1fr;
          gap: 5rem;
          align-items: center;
        }
        
        .about-image {
          position: relative;
          border-radius: var(--radius-lg);
          overflow: hidden;
          box-shadow: 0 25px 50px -12px rgba(139, 69, 19, 0.25);
          border: 8px solid var(--light-bg);
          aspect-ratio: 4/5;
        }
        
        .about-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.7s ease;
        }
        
        .about-image:hover img {
          transform: scale(1.05);
        }
        
        .image-caption {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          background: linear-gradient(to top, rgba(0,0,0,0.9), transparent);
          color: var(--white);
          padding: 3rem 1.5rem 1.5rem 1.5rem;
          text-align: center;
          font-weight: 600;
          letter-spacing: 1px;
        }
        
        .about-content h2 {
          color: var(--primary-color);
          font-size: 0.9rem;
          font-weight: 800;
          letter-spacing: 4px;
          text-transform: uppercase;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .about-content h2::before {
          content: "";
          display: block;
          width: 40px;
          height: 2px;
          background-color: var(--primary-color);
        }
        
        .about-content h3 {
          font-size: 3rem;
          font-family: 'Playfair Display', serif;
          margin-bottom: 2rem;
          color: var(--text-main);
          line-height: 1.2;
        }
        
        .about-content p {
          font-size: 1.1rem;
          color: var(--text-light);
          margin-bottom: 1.5rem;
          line-height: 1.8;
        }
        
        .about-features {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
          margin: 3rem 0;
        }
        
        .about-feature {
          text-align: center;
          padding: 2rem 1rem;
          background: var(--light-bg);
          border-radius: var(--radius-md);
          border: 1px solid rgba(139, 69, 19, 0.1);
          transition: all 0.4s ease;
          position: relative;
          overflow: hidden;
          z-index: 1;
        }

        .about-feature::before {
          content: "";
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: var(--primary-color);
          z-index: -1;
          transform: translateY(100%);
          transition: transform 0.4s ease;
        }
        
        .about-feature:hover {
          transform: translateY(-8px);
          box-shadow: var(--shadow-lg);
          border-color: transparent;
        }

        .about-feature:hover::before {
          transform: translateY(0);
        }

        .about-feature:hover h4, 
        .about-feature:hover p, 
        .about-feature:hover .feature-icon-wrapper {
          color: var(--white) !important;
        }
        
        .feature-icon-wrapper {
          font-size: 2.5rem;
          margin-bottom: 1rem;
          transition: var(--transition);
        }

        .about-feature h4 {
          font-size: 1.1rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: var(--text-main);
          transition: var(--transition);
        }

        .about-feature p {
          font-size: 0.85rem;
          color: var(--text-light);
          transition: var(--transition);
          margin: 0;
        }
        
        .about-quote {
          position: relative;
          background: transparent;
          padding: 1.5rem 0 0 3.5rem;
          border-left: none;
          margin-top: 2rem;
        }

        .about-quote::before {
          content: "“";
          position: absolute;
          top: -20px;
          left: 0;
          font-size: 6rem;
          font-family: 'Playfair Display', serif;
          color: rgba(139, 69, 19, 0.15);
          line-height: 1;
        }
        
        .about-quote blockquote {
          font-style: italic;
          font-size: 1.3rem;
          color: var(--text-main);
          margin: 0 0 1.5rem 0;
          font-family: 'Playfair Display', serif;
          line-height: 1.6;
        }
        
        .about-quote cite {
          font-weight: 700;
          color: var(--primary-color);
          text-transform: uppercase;
          letter-spacing: 2px;
          font-size: 0.85rem;
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .about-quote cite::before {
          content: "";
          width: 30px;
          height: 1px;
          background-color: var(--primary-color);
        }
        
        /* TOUR SECTION */
        .tour-section {
          padding: 6rem 5%;
          background-color: var(--white);
        }
        
        .tour-container {
          max-width: 1200px;
          margin: 0 auto;
          background: var(--light-bg);
          border-radius: 3rem;
          overflow: hidden;
          box-shadow: var(--shadow-lg);
          display: grid;
          grid-template-columns: 1fr 1fr;
        }
        
        .tour-info-wrapper {
          padding: 4rem;
          background: var(--dark-bg);
          color: var(--white);
        }
        
        .tour-header h2 {
          font-size: 2.5rem;
          font-family: 'Playfair Display', serif;
          margin-bottom: 1rem;
        }
        
        .tour-header p {
          color: var(--secondary-color);
          font-size: 1.1rem;
          margin-bottom: 2rem;
        }
        
        .tour-images {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        
        .tour-images img {
          border-radius: var(--radius-md);
          object-fit: cover;
          width: 100%;
        }
        
        .tour-image-main { height: 250px; }
        
        .tour-images-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        
        .tour-images-grid img { height: 150px; }
        
        .tour-form-wrapper {
          padding: 4rem;
          background: var(--white);
        }
        
        .tour-form-wrapper h3 {
          font-size: 2rem;
          margin-bottom: 2rem;
          color: var(--text-main);
        }
        
        .custom-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }
        
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
        }
        
        .custom-input, .custom-select, .custom-textarea {
          width: 100%;
          padding: 1rem 1.25rem;
          border: 1px solid #E0E0E0;
          border-radius: var(--radius-md);
          background: #FAFAFA;
          font-family: inherit;
          font-size: 1rem;
          transition: var(--transition);
        }
        
        .custom-input:focus, .custom-select:focus, .custom-textarea:focus {
          outline: none;
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(139, 69, 19, 0.1);
        }
        
        .checkbox-group {
          background: var(--light-bg);
          padding: 1rem;
          border-radius: var(--radius-md);
          border: 1px solid #E0E0E0;
          transition: var(--transition);
        }
        
        .checkbox-group:hover {
          border-color: var(--primary-color);
        }
        
        .checkbox-group input[type="checkbox"] {
          width: 20px;
          height: 20px;
          accent-color: var(--primary-color);
        }
        
        .btn-submit {
          background: var(--dark-bg);
          color: var(--white);
          border: none;
          padding: 1.25rem;
          font-size: 1.1rem;
          font-weight: bold;
          border-radius: var(--radius-md);
          cursor: pointer;
          transition: var(--transition);
          margin-top: 1rem;
        }
        
        .btn-submit:hover {
          background: var(--primary-color);
        }
        
        /* VENTA POR TONELADA (Wholesale) */
        .wholesale-section {
          background-color: var(--primary-color);
          color: var(--white);
          padding: 6rem 5%;
          background-image: linear-gradient(135deg, var(--primary-color) 0%, var(--dark-bg) 100%);
        }
        
        .wholesale-container {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .wholesale-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
        }
        
        .wholesale-card {
          background: rgba(255,255,255,0.1);
          backdrop-filter: blur(10px);
          padding: 2rem;
          border-radius: var(--radius-lg);
          text-align: center;
          border: 1px solid rgba(255,255,255,0.2);
          transition: var(--transition);
        }
        
        .wholesale-card:hover {
          transform: translateY(-10px);
          background: rgba(255,255,255,0.15);
        }
        
        .wholesale-icon {
          font-size: 3rem;
          display: block;
          margin-bottom: 1rem;
        }
        
        .wholesale-card h3 {
          font-size: 1.25rem;
          margin-bottom: 1rem;
        }
        
        .wholesale-card p {
          font-size: 0.95rem;
          color: #E0E0E0;
          line-height: 1.6;
        }
        
        /* GREEN COFFEE (Variedades) */
        .green-coffee-section {
          padding: 6rem 5%;
          background-color: var(--white);
        }
        
        .green-coffee-container {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .coffee-varieties-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
        }
        
        .variety-card {
          background: var(--light-bg);
          border-radius: var(--radius-md);
          padding: 2rem;
          border: 1px solid #E0E0E0;
          transition: var(--transition);
        }
        
        .variety-card:hover {
          box-shadow: var(--shadow-md);
          border-color: var(--secondary-color);
        }
        
        .variety-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1.5rem;
          border-bottom: 1px solid #E0E0E0;
          padding-bottom: 1rem;
        }
        
        .variety-icon {
          font-size: 2rem;
        }
        
        .variety-header h3 {
          font-size: 1.25rem;
          color: var(--text-main);
        }
        
        .variety-detail {
          margin-bottom: 0.8rem;
          color: var(--text-light);
          font-size: 0.95rem;
        }
        
        .variety-detail strong {
          color: var(--text-main);
        }
        
        .variety-footer {
          margin-top: 1.5rem;
          padding-top: 1rem;
          border-top: 1px solid #E0E0E0;
          text-align: right;
        }
        
        .variety-price-badge {
          background: var(--dark-bg);
          color: var(--white);
          padding: 0.4rem 1rem;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: bold;
        }
        
        /* CONTACTO COMERCIAL */
        .contacto-comercial-section {
          padding: 6rem 5%;
          background-color: var(--light-bg);
        }
        
        .contacto-comercial-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          background: var(--white);
          border-radius: 3rem;
          padding: 4rem;
          box-shadow: var(--shadow-lg);
        }
        
        .contacto-info-wrapper h2 {
          font-size: 2.5rem;
          font-family: 'Playfair Display', serif;
          margin-bottom: 1rem;
          color: var(--primary-color);
        }
        
        .contacto-subtitle {
          color: var(--text-light);
          font-size: 1.1rem;
          margin-bottom: 3rem;
        }
        
        .contacto-metodos {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }
        
        .metodo {
          display: flex;
          align-items: flex-start;
          gap: 1.5rem;
        }
        
        .metodo-icon {
          font-size: 2rem;
          background: var(--light-bg);
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }
        
        .metodo h4 {
          font-size: 1.1rem;
          margin-bottom: 0.3rem;
          color: var(--text-main);
        }
        
        .metodo p {
          color: var(--text-light);
          font-size: 0.95rem;
        }
        
        .contacto-form-wrapper h3 {
          font-size: 2rem;
          margin-bottom: 2rem;
        }
        
        /* MAPA Y TESTIMONIOS */
        .mapa-section, .testimonials-section {
          padding: 6rem 5%;
          background-color: var(--white);
        }
        
        .mapa-container {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .mapa-wrapper {
          height: 400px;
          border-radius: var(--radius-lg);
          overflow: hidden;
          box-shadow: var(--shadow-md);
          margin-bottom: 3rem;
        }
        
        .mapa-wrapper iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
        
        .mapa-info {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
        }
        
        .mapa-info-item {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          background: var(--light-bg);
          padding: 2rem;
          border-radius: var(--radius-md);
        }
        
        .mapa-icon {
          font-size: 2.5rem;
        }
        
        .testimonials-container {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .testimonials-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
        }
        
        .testimonial-card {
          background: var(--light-bg);
          padding: 2.5rem;
          border-radius: var(--radius-lg);
          border: 1px solid #E0E0E0;
          position: relative;
        }
        
        .testimonial-stars {
          color: #F59E0B;
          font-size: 1.5rem;
          margin-bottom: 1rem;
          letter-spacing: 2px;
        }
        
        .testimonial-text {
          font-size: 1.05rem;
          color: var(--text-main);
          line-height: 1.8;
          font-style: italic;
          margin-bottom: 2rem;
        }
        
        .testimonial-author {
          display: flex;
          align-items: center;
          gap: 1rem;
          border-top: 1px solid #E0E0E0;
          padding-top: 1.5rem;
        }
        
        .author-avatar {
          width: 50px;
          height: 50px;
          background: var(--primary-color);
          color: var(--white);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 1.2rem;
        }
        
        .testimonial-author strong {
          display: block;
          color: var(--text-main);
        }
        
        .testimonial-author span {
          font-size: 0.85rem;
          color: var(--text-light);
        }
        
        /* RESPONSIVE */
        @media (max-width: 968px) {
          .about-container, .tour-container, .form-row, .contacto-comercial-container {
            grid-template-columns: 1fr;
          }
          
          .hero-title { font-size: 3rem; }
          .hero-stats { flex-direction: column; gap: 1.5rem; }
          
          .tour-info-wrapper, .tour-form-wrapper, .contacto-comercial-container { padding: 2rem; }
          
          .mapa-info { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="home-container">
        
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-background"></div>
          <img src={fincaImg} alt="Finca" className="hero-background-img" />
          <div className="hero-particles"></div>
          <div className="hero-content">
            <span className="hero-subtitle-top">Tradición desde 1880</span>
            <h1 className="hero-title">
              Román Valderrábano
              <span className="hero-subtitle">El Catador</span>
            </h1>
            <p className="hero-description">
              Desde 1880 cultivando los mejores granos de café en la Sierra Norte de Puebla. 
              Tradición familiar que ha pasado de generación en generación.
            </p>
            <p className="hero-description-small">
              <strong>ROMÁN VALDERRÁBANO, EL CATADOR</strong>, cuenta con la experiencia ancestral 
              de 5 generaciones y es catador Q Grader, para producir y procesar uno de los mejores 
              cafés del Estado de Puebla.
            </p>
            <div className="hero-buttons">
              <Link to="/products" className="btn-premium">
                <span>☕</span> Comprar Café
              </Link>
              <a href="#tour" className="btn-outline-light" onClick={(e) => {
                e.preventDefault();
                document.getElementById('tour')?.scrollIntoView({ behavior: 'smooth' });
              }}>
                <span>🌿</span> Conoce Nuestro Recorrido
              </a>
            </div>
            
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">1880</span>
                <span className="stat-label">Años de tradición</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">5</span>
                <span className="stat-label">Generaciones</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">🏆</span>
                <span className="stat-label">Catador Q Grader</span>
              </div>
            </div>
          </div>
        </section>

        {/* Sección de Videos (Rutas a la carpeta Public) */}
        <section className="videos-section">
          <div className="section-header-dark">
            <h2>Conoce Nuestra Historia</h2>
            <p>Videos que muestran nuestra pasión por el café</p>
          </div>

          <div className="videos-grid">
            <div className="video-card">
              <div className="video-container">
                <video controls preload="metadata" className="video-player">
                  <source src={vid1} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div className="video-info">
                <h3>Recorrido por Nuestra Finca</h3>
                <p>Conoce el proceso tradicional del café en nuestras instalaciones</p>
              </div>
            </div>

            <div className="video-card">
              <div className="video-container">
                <video controls preload="metadata" className="video-player">
                  <source src={vid2} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div className="video-info">
                <h3>Cata de Café con Román</h3>
                <p>Aprende a identificar los mejores granos con nuestro experto</p>
              </div>
            </div>

            <div className="video-card">
              <div className="video-container">
                <video controls preload="metadata" className="video-player">
                  <source src={vid3} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div className="video-info">
                <h3>Cocina Tradicional de Humo</h3>
                <p>Técnica ancestral en ollas de barro que intensifica los sabores</p>
              </div>
            </div>

            <div className="video-card">
              <div className="video-container">
                <video controls preload="metadata" className="video-player">
                  <source src={vid4} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div className="video-info">
                <h3>De la Finca a tu Taza</h3>
                <p>Todo el proceso de producción de nuestro café premium</p>
              </div>
            </div>
          </div>
        </section>

        {/* Productos Destacados */}
        <section className="featured-products">
          <div className="section-header-light">
            <span className="subtitle-top">Tienda en Línea</span>
            <h2>Productos Destacados</h2>
            <p>Nuestra selección especial para ti</p>
          </div>

          <div className="products-grid">
            {featuredProducts.map(product => (
              <div key={product.id} className="product-card">
                <Link to={`/product/${product.id}`} className="product-link">
                  <div className="product-image-container">
                    <img 
                      src={getImageUrl(product.imagen_portada)} 
                      alt={product.nombre} 
                      className="product-image" 
                      onError={(e) => { e.target.src = '/images/default-product.jpg'; }}
                    />
                    <span className="product-badge">⭐ Destacado</span>
                  </div>
                  <div className="product-info">
                    <span className="product-category">{product.categoria}</span>
                    <h3 className="product-name">{product.nombre}</h3>
                    <p className="product-description">{product.descripcion_corta}</p>
                    <div className="product-footer">
                      <span className="product-price">${parseFloat(product.precio).toFixed(2)} MXN</span>
                    </div>
                  </div>
                </Link>
                <div className="product-card-action">
                  <button className="add-to-cart-btn-card">
                    <span>🛒</span> Agregar
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="section-footer text-center" style={{marginTop: '3rem', textAlign: 'center'}}>
            <Link to="/products" className="btn-premium">
              Ver Todos los Productos
            </Link>
          </div>
        </section>

        {/* 🔥 SECCIÓN SOBRE NOSOTROS (DISEÑO MEJORADO) 🔥 */}
        <section className="about-section">
          <div className="about-container">
            <div className="about-image">
              <img src={romanImg} alt="Román Valderrábano, El Catador" />
              <div className="image-caption">Román Valderrábano, El Catador - Q Grader</div>
            </div>
            
            <div className="about-content">
              <h2>Nuestra Historia</h2>
              <h3>Desde 1880, una tradición familiar</h3>
              <p>
                La familia Valderrábano inició en el cultivo de café desde <strong>1880</strong>, 
                convirtiéndose en una tradición familiar que se ha transmitido de generación en 
                generación hasta llegar a nuestros días.
              </p>
              <p>
                Hoy, <strong>ROMÁN VALDERRÁBANO, EL CATADOR</strong>, cuenta con la experiencia 
                ancestral de 5 generaciones, además de ser <strong>catador Q Grader</strong>, para 
                producir y procesar uno de los mejores cafés del Estado de Puebla en la 
                <strong> Sierra Norte de Xicotepec de Juárez, Pueblo Mágico</strong>.
              </p>
              <p>
                Nuestra <strong>Cocina Tradicional de Humo</strong> utiliza técnicas ancestrales 
                en ollas de barro que intensifican los sabores y conservan los nutrientes, 
                ofreciendo resultados únicos en nuestra gastronomía.
              </p>

              <div className="about-features">
                <div className="about-feature">
                  <div className="feature-icon-wrapper">🌱</div>
                  <h4>1880</h4>
                  <p>5 Generaciones</p>
                </div>
                <div className="about-feature">
                  <div className="feature-icon-wrapper">🏺</div>
                  <h4>Cocina Humo</h4>
                  <p>Técnica en barro</p>
                </div>
                <div className="about-feature">
                  <div className="feature-icon-wrapper">🏆</div>
                  <h4>Q Grader</h4>
                  <p>Certificado</p>
                </div>
              </div>

              <div className="about-quote">
                <blockquote>
                  "El café no es solo un grano, es la historia de nuestra tierra y el humo de nuestros fogones ancestrales"
                </blockquote>
                <cite>Román Valderrábano, El Catador</cite>
              </div>
            </div>
          </div>
        </section>

        {/* Sección de Tour y Reservas */}
        <section id="tour" className="tour-section">
          <div className="tour-container">
            <div className="tour-info-wrapper">
              <div className="tour-header">
                <h2>Conoce Nuestro Recorrido</h2>
                <p>Vive el fascinante mundo del café en la Sierra Norte de Puebla</p>
              </div>

              <div className="tour-content">
                <div className="tour-location" style={{marginBottom: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem', color: 'var(--secondary-color)'}}>
                  <span>📍 Xicotepec de Juárez, Pueblo Mágico</span>
                  <span>🌲 Bosque Mesófilo de Montaña</span>
                </div>
                
                <h3 style={{fontSize: '1.5rem', marginBottom: '0.5rem', color: 'var(--secondary-color)'}}>Tour Completo: $300 MXN / pp</h3>
                {/* 🔥 AVISO DE COBRO MÍNIMO 🔥 */}
                <p style={{color: '#E57373', fontWeight: 'bold', marginBottom: '1.5rem', fontSize: '0.9rem', lineHeight: '1.4'}}>
                  * Nota importante: El costo mínimo para abrir cualquier reservación es el equivalente a 4 personas (Incluso si asiste solo 1 persona).
                </p>

                <p className="tour-description" style={{marginBottom: '2rem', lineHeight: '1.6'}}>
                  Nos encontramos en la Sierra Norte de Puebla, en las más altas montañas. 
                  Nuestro recorrido comienza en nuestra procesadora y finca, donde presenciamos un 
                  bosque mesófilo de montaña, clima ideal para producir uno de los mejores cafés del país.
                </p>
                
                <ul className="tour-features-list" style={{listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '1.5rem'}}>
                  <li style={{display: 'flex', gap: '1rem'}}>
                    <span style={{fontSize: '1.5rem'}}>🌿</span>
                    <div>
                      <strong style={{display: 'block', fontSize: '1.1rem'}}>Recorrido por el cafetal <span style={{color: 'var(--secondary-color)', fontSize: '0.9rem'}}>$150 MXN / pp</span></strong>
                      <p style={{color: '#CCC', fontSize: '0.9rem', marginTop: '0.25rem'}}>Visita guiada por nuestras plantaciones en el bosque mesófilo.</p>
                    </div>
                  </li>
                  <li style={{display: 'flex', gap: '1rem'}}>
                    <span style={{fontSize: '1.5rem'}}>👃</span>
                    <div>
                      <strong style={{display: 'block', fontSize: '1.1rem'}}>Taller de Catación <span style={{color: 'var(--secondary-color)', fontSize: '0.9rem'}}>$200 MXN / pp</span></strong>
                      <p style={{color: '#CCC', fontSize: '0.9rem', marginTop: '0.25rem'}}>Aprende a identificar notas y aromas con Román Valderrábano.</p>
                    </div>
                  </li>
                  <li style={{display: 'flex', gap: '1rem'}}>
                    <span style={{fontSize: '1.5rem'}}>🍽️</span>
                    <div>
                      <strong style={{display: 'block', fontSize: '1.1rem'}}>Cocina Tradicional de Humo <span style={{color: 'var(--secondary-color)', fontSize: '0.9rem'}}>$200 MXN / pp</span></strong>
                      <p style={{color: '#CCC', fontSize: '0.9rem', marginTop: '0.25rem'}}>Experiencia gastronómica en ollas de barro (Mínimo 10 personas).</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="tour-images" style={{marginTop: '3rem'}}>
                <img src={bosqueImg} alt="Bosque mesófilo" className="tour-image-main" />
                <div className="tour-images-grid">
                  <img src={fincaImg} alt="Finca cafetalera" />
                  <img src={cocinaHumoImg} alt="Cocina tradicional de humo" />
                </div>
              </div>
            </div>

            <div className="tour-form-wrapper">
              <h3>Reserva tu Experiencia</h3>
              <form onSubmit={handleTourSubmit} className="custom-form">
                <div className="form-group">
                  <input type="text" name="name" placeholder="Nombre completo" className="custom-input" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input type="email" name="email" placeholder="Email" className="custom-input" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <input type="tel" name="phone" placeholder="Teléfono" className="custom-input" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} required />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input type="date" name="date" className="custom-input" value={formData.date} onChange={(e) => setFormData({...formData, date: e.target.value})} min={new Date().toISOString().split('T')[0]} required />
                  </div>
                  <div className="form-group">
                    <select name="people" className="custom-select" value={formData.people} onChange={(e) => setFormData({...formData, people: e.target.value})}>
                      {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15].map(num => (
                        <option key={num} value={num}>{num} {num === 1 ? 'persona' : 'personas'}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group checkbox-group">
                  <label style={{display: 'flex', alignItems: 'center', gap: '10px', width: '100%', cursor: 'pointer'}}>
                    <input type="checkbox" name="includeCatacion" checked={formData.includeCatacion} onChange={(e) => setFormData({...formData, includeCatacion: e.target.checked})} />
                    Incluir Taller de Catación ($200 MXN / pp)
                  </label>
                </div>

                <div className="form-group checkbox-group">
                  <label style={{display: 'flex', alignItems: 'center', gap: '10px', width: '100%', cursor: 'pointer'}}>
                    <input type="checkbox" name="includeRecorrido" checked={formData.includeRecorrido} onChange={(e) => setFormData({...formData, includeRecorrido: e.target.checked})} />
                    Incluir Recorrido por el cafetal ($150 MXN / pp)
                  </label>
                </div>

                {formData.includeCatacion && formData.includeRecorrido && (
                  <div className="tour-completo-info" style={{background: '#FFF3E0', color: '#E65100', padding: '1.2rem', borderRadius: '12px', fontSize: '0.95rem', borderLeft: '4px solid #E65100'}}>
                    <strong style={{display: 'block', fontSize: '1.1rem', marginBottom: '5px'}}>✨ Tour Completo: $300 MXN / pp</strong>
                    Ahorras $50 MXN por persona al tomar el recorrido y la catación.
                    <span style={{display: 'block', marginTop: '8px', fontSize: '0.85rem', color: '#BF360C'}}>* Recordatorio: Cobro mínimo garantizado de 4 personas.</span>
                  </div>
                )}

                <div className="form-group checkbox-group">
                  <label style={{display: 'flex', alignItems: 'center', gap: '10px', width: '100%', cursor: 'pointer'}}>
                    <input type="checkbox" name="includeBuffet" checked={formData.includeBuffet} onChange={(e) => setFormData({...formData, includeBuffet: e.target.checked})} />
                    Agregar Cocina de Humo ($200 MXN extra / pp)
                  </label>
                  {formData.includeBuffet && parseInt(formData.people) < 10 && (
                    <small style={{display: 'block', color: '#D32F2F', marginTop: '5px', fontWeight: 'bold'}}>⚠️ Esta experiencia requiere un mínimo estricto de 10 personas.</small>
                  )}
                </div>

                <div className="form-group">
                  <textarea name="message" placeholder="Mensaje o requerimientos especiales (opcional)" rows="3" className="custom-textarea" value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})}></textarea>
                </div>

                <button type="submit" className="btn-submit">Reservar Ahora</button>
              </form>
            </div>
          </div>
        </section>

        {/* Sección de Café Verde por Tonelada */}
        <section className="wholesale-section">
          <div className="wholesale-container">
            <div className="section-header-dark">
              <h2>Venta de Café Verde por Tonelada</h2>
              <p>Para tostadores, importadores y productores</p>
            </div>

            <div className="wholesale-grid">
              <div className="wholesale-card">
                <span className="wholesale-icon">🚢</span>
                <h3>Exportación Directa</h3>
                <p>Sin intermediarios, garantizando el mejor precio y calidad.</p>
              </div>
              <div className="wholesale-card">
                <span className="wholesale-icon">📋</span>
                <h3>Trazabilidad Completa</h3>
                <p>Cada lote con certificado de origen y análisis de taza.</p>
              </div>
              <div className="wholesale-card">
                <span className="wholesale-icon">🌍</span>
                <h3>Certificaciones</h3>
                <p>Orgánico, Comercio Justo, Rainforest Alliance.</p>
              </div>
              <div className="wholesale-card">
                <span className="wholesale-icon">📦</span>
                <h3>Logística Integrada</h3>
                <p>Envíos a cualquier parte del mundo.</p>
              </div>
            </div>

            <div className="wholesale-cta text-center" style={{marginTop: '4rem', textAlign: 'center'}}>
              <p style={{color: '#FFF', marginBottom: '1rem', fontSize: '1.2rem'}}>¿Interesado en compras por tonelada?</p>
              <a href="#contacto-comercial" className="btn-outline-light" onClick={(e) => {
                e.preventDefault();
                document.getElementById('contacto-comercial')?.scrollIntoView({ behavior: 'smooth' });
              }}>
                Solicitar Cotización
              </a>
            </div>
          </div>
        </section>

        {/* Sección de Variedades de Café Verde */}
        <section className="green-coffee-section">
          <div className="green-coffee-container">
            <div className="section-header-light">
              <span className="subtitle-top">Catálogo Mayorista</span>
              <h2>Variedades de Café Verde</h2>
              <p>Seleccionamos los mejores granos de nuestras fincas y productores aliados</p>
            </div>

            <div className="coffee-varieties-grid">
              {greenCoffeeVarieties.map((variety, index) => (
                <div key={index} className="variety-card">
                  <div className="variety-header">
                    <span className="variety-icon">🌿</span>
                    <h3>{variety.nombre}</h3>
                  </div>
                  <div className="variety-body">
                    <div className="variety-detail"><strong>Origen:</strong> {variety.origen}</div>
                    <div className="variety-detail"><strong>Altitud:</strong> {variety.altitud}</div>
                    <div className="variety-detail"><strong>Perfil:</strong> {variety.perfil_taza}</div>
                  </div>
                  <div className="variety-footer">
                    <span className="variety-price-badge">Consultar Precio</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Sección de Contacto Comercial */}
        <section id="contacto-comercial" className="contacto-comercial-section">
          <div className="contacto-comercial-container">
            <div className="contacto-info-wrapper">
              <h2>Contacto para Ventas por Tonelada</h2>
              <p className="contacto-subtitle">Nuestro equipo comercial te responderá en máximo 24 horas</p>

              <div className="contacto-metodos">
                <div className="metodo">
                  <span className="metodo-icon">📞</span>
                  <div>
                    <h4>Teléfono Comercial</h4>
                    <p>+52 1 764 105 7461</p>
                  </div>
                </div>
                <div className="metodo">
                  <span className="metodo-icon">✉️</span>
                  <div>
                    <h4>Email Corporativo</h4>
                    <p>romanvalderrabanoelcatador@gmail.com</p>
                  </div>
                </div>
                <div className="metodo">
                  <span className="metodo-icon">💬</span>
                  <div>
                    <h4>WhatsApp Business</h4>
                    <p>+52 1 764 105 7461</p>
                  </div>
                </div>
                <div className="metodo">
                  <span className="metodo-icon">⏰</span>
                  <div>
                    <h4>Horario de Atención</h4>
                    <p>Lun - Vie: 8am - 6pm | Sáb: 9am - 2pm</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contacto-form-wrapper">
              <h3>Solicita tu Cotización</h3>
              <form onSubmit={handleContactSubmit} className="custom-form">
                <div className="form-group">
                  <input type="text" name="name" placeholder="Nombre completo *" className="custom-input" value={contactData.name} onChange={(e) => setContactData({...contactData, name: e.target.value})} required />
                </div>
                <div className="form-row">
                  <input type="email" name="email" placeholder="Email *" className="custom-input" value={contactData.email} onChange={(e) => setContactData({...contactData, email: e.target.value})} required />
                  <input type="text" name="company" placeholder="Empresa" className="custom-input" value={contactData.company} onChange={(e) => setContactData({...contactData, company: e.target.value})} />
                </div>
                <div className="form-row">
                  <input type="tel" name="phone" placeholder="Teléfono *" className="custom-input" value={contactData.phone} onChange={(e) => setContactData({...contactData, phone: e.target.value})} required />
                  <select name="tonnage" className="custom-select" value={contactData.tonnage} onChange={(e) => setContactData({...contactData, tonnage: e.target.value})}>
                    <option value="1">1 tonelada (muestra)</option>
                    <option value="5">5 toneladas</option>
                    <option value="10">10 toneladas</option>
                    <option value="20">20 toneladas</option>
                    <option value="50">50 toneladas</option>
                    <option value="100">100+ toneladas</option>
                  </select>
                </div>
                <div className="form-group">
                  <select name="quality" className="custom-select" value={contactData.quality} onChange={(e) => setContactData({...contactData, quality: e.target.value})} required>
                    <option value="">Selecciona calidad *</option>
                    <option value="superior">Oro Natural Superior</option>
                    <option value="pl10">Oro PL-10</option>
                    <option value="pl20">Oro PL-20</option>
                    <option value="altura">Altura Premium</option>
                    <option value="especialidad">Café de Especialidad (85+ puntos)</option>
                    <option value="gourmet">Gourmet (90+ puntos)</option>
                  </select>
                </div>
                <div className="form-group">
                  <textarea name="message" placeholder="Requerimientos específicos (opcional)" rows="4" className="custom-textarea" value={contactData.message} onChange={(e) => setContactData({...contactData, message: e.target.value})}></textarea>
                </div>
                <button type="submit" className="btn-submit">Solicitar Cotización</button>
              </form>
            </div>
          </div>
        </section>

        {/* Sección de Mapa */}
        <section className="mapa-section">
          <div className="mapa-container">
            <div className="section-header-light">
              <span className="subtitle-top">Pueblo Mágico</span>
              <h2>Visítanos en la Sierra Norte</h2>
              <p>Xicotepec de Juárez, Puebla</p>
            </div>

            <div className="mapa-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1880.387450255424!2d-97.964414!3d20.275843!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d085564fd3d265%3A0xf644826230ec25e5!2sZaragoza%20146%2C%20Centro%2C%2073080%20Xicotepec%20de%20Ju%C3%A1rez%2C%20Pue.!5e0!3m2!1ses-419!2smx!4v1700000000000!5m2!1ses-419!2smx"
                title="Ubicación de Román Valderrábano El Catador en Xicotepec"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="mapa-info">
              <div className="mapa-info-item">
                <span className="mapa-icon">📍</span>
                <div>
                  <strong>Dirección</strong>
                  <p>Zaragoza 146, Centro</p>
                </div>
              </div>
              <div className="mapa-info-item">
                <span className="mapa-icon">⏰</span>
                <div>
                  <strong>Horarios</strong>
                  <p>Lun-Sáb: 8am - 6pm</p>
                </div>
              </div>
              <div className="mapa-info-item">
                <span className="mapa-icon">📞</span>
                <div>
                  <strong>Teléfono</strong>
                  <p>+52 1 764 105 7461</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Sección de Testimonios */}
        <section className="testimonials-section">
          <div className="testimonials-container">
            <div className="section-header-light">
              <span className="subtitle-top">Reseñas</span>
              <h2>Lo que dicen nuestros clientes</h2>
            </div>

            <div className="testimonials-grid">
              <div className="testimonial-card">
                <div className="testimonial-stars">★★★★★</div>
                <p className="testimonial-text">
                  "El café de Román tiene una consistencia increíble. Llevamos 5 años comprándoles café verde por tonelada y nunca nos han decepcionado. La trazabilidad es excepcional."
                </p>
                <div className="testimonial-author">
                  <div className="author-avatar">JC</div>
                  <div>
                    <strong>Juan Carlos Hernández</strong>
                    <span>Tostador Artesanal, CDMX</span>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-stars">★★★★★</div>
                <p className="testimonial-text">
                  "El tour por la finca fue una experiencia transformadora. Ver el proceso de primera mano y probar la cocina tradicional de humo cambió mi perspectiva del café. ¡Volveré cada año!"
                </p>
                <div className="testimonial-author">
                  <div className="author-avatar">ML</div>
                  <div>
                    <strong>María Fernanda López</strong>
                    <span>Barista, Guadalajara</span>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-stars">★★★★★</div>
                <p className="testimonial-text">
                  "Como importador, valoro la honestidad y calidad de Román Valderrábano. Sus lotes de Oro PL-20 son consistentes y el perfil de taza es exactamente lo que buscan mis clientes en Europa."
                </p>
                <div className="testimonial-author">
                  <div className="author-avatar">CM</div>
                  <div>
                    <strong>Carlos Mendoza</strong>
                    <span>Importador, Barcelona</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;